import React, { useEffect, useState } from "react";

const services = [
  {
    title: "FMCG Carrying & Forwarding (C&F) – DS Spiceco",
    shortText: "Authorized C&F partner for DS Spiceco FMCG products.",
    fullText:
      "We operate as the official Carrying & Forwarding (C&F) partner for DS Spiceco. Our operations include warehousing, inventory management, order processing, and seamless distribution to distributors and retailers across assigned territories.",
    image: "/cf.jpeg",
  },
  {
    title: "Distributor – OPPO (Mobiles & Accessories)",
    shortText: "Authorized distributor in selective areas of Ghaziabad.",
    fullText:
      "We are an official distributor of OPPO mobile phones and accessories in selected areas of Ghaziabad. Our services include bulk supply, dealer network management, promotional support, and after-sales coordination.",
    image: "https://image.oppo.com/content/dam/oppo/sg/mkt/flagship-store/nex-new.jpg",
  },
  {
    title: "Distributor – Cellcore Appliances",
    shortText: "Fridges, Air Conditioners & LED TVs distribution.",
    fullText:
      "We distribute Cellcore home appliances including refrigerators, air conditioners, and LED TVs. We ensure efficient logistics, retailer supply chain management, and consistent product availability in Ghaziabad regions.",
    image: "https://1repair.in/wp-content/uploads/2023/06/service-center-3.png",
  },
  {
    title: "Merchant Export & Import",
    shortText: "Active participation in international trade.",
    fullText:
      "We actively engage in merchant export and import operations, facilitating cross-border trade of goods with reliable sourcing, documentation management, and international compliance standards.",
    image: "https://media.philstar.com/photos/2019/03/19/bus4-export-file_2019-03-19_20-12-52.jpg",
  },
];

const Whatwedo = () => {
  const [current, setCurrent] = useState(0);
  const [cardsPerSlide, setCardsPerSlide] = useState(3);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  // Responsive logic
  useEffect(() => {
    const update = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      setCardsPerSlide(mobile ? 1 : 3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const totalSlides = Math.ceil(services.length / cardsPerSlide);

  // Auto-slide on mobile only
  useEffect(() => {
    if (!isMobile) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % totalSlides);
    }, 3000);
    return () => clearInterval(interval);
  }, [isMobile, totalSlides]);

  return (
    <section className="py-14 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10 text-center">
          What We Do
        </h2>

        {/* Slider */}
        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {Array.from({ length: totalSlides }).map((_, slideIdx) => {
              const start = slideIdx * cardsPerSlide;
              const slideCards = services.slice(start, start + cardsPerSlide);

              return (
                <div
                  key={slideIdx}
                  className="w-full flex-shrink-0 grid grid-cols-1 md:grid-cols-3 gap-8 px-2"
                >
                  {slideCards.map((service, index) => (
                    <div
                      key={index}
                      className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition"
                    >
                      <div className="relative h-56 overflow-hidden">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                      </div>

                      <div className="p-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                          {service.title}
                        </h3>
                        <p className="text-gray-600 mb-4">
                          {service.shortText}
                        </p>
                        <button
                          onClick={() => setSelectedService(service)}
                          className="text-blue-600 font-medium hover:underline"
                        >
                          Read More →
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center mt-6 space-x-2">
          {Array.from({ length: totalSlides }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`w-3 h-3 rounded-full transition
              ${idx === current ? "bg-blue-600 scale-110" : "bg-gray-300"}`}
            />
          ))}
        </div>
      </div>

      {/* Modal Dialog */}
      {selectedService && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-2xl max-w-lg w-full p-6 relative animate-fadeIn">
            <button
              onClick={() => setSelectedService(null)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black"
            >
              ✕
            </button>

            <h3 className="text-2xl font-bold mb-4">
              {selectedService.title}
            </h3>

            <p className="text-gray-600 mb-6">
              {selectedService.fullText}
            </p>

            <button
              onClick={() => setSelectedService(null)}
              className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Whatwedo;